import { useEffect, useState } from "react";
import CustomDataGrid from "../../../common/js/components/CustomDataGrid";
import { pageSize } from "../utils/constants";

const BrokerDealsGrid = ({
    brokerDeals,
    columns,
    dealsPage,
    dealView,
    getDealsData,
    isLoading,
    resetDealsTab,
    setDealsPage,
    setDealsSort,
}) => {
    const defaultSort = dealView === "broker_closed" ? "batchDate,desc" : "transactionDate,desc";
    const [sortModel, setSortModel] = useState([]);
    const dataDeals = brokerDeals?.content ?? [];
    const totalCount = brokerDeals?.totalElements ?? 0;

    useEffect(() => {
        resetDealsTab();
        setDealsSort(defaultSort);
        getDealsData();
    }, [dealView]);

    const handlePageChange = (value) => {
        setDealsPage(value);
        getDealsData();
    };

    const handleSortModelChange = (newSortModel) => {
        setDealsPage(1);
        setSortModel(newSortModel);
        const newSort =
            newSortModel[0]?.field && newSortModel[0]?.sort ? `${newSortModel[0].field},${newSortModel[0].sort}` : null;
        setDealsSort(newSort);
        getDealsData();
    };

    return (
        <CustomDataGrid
            rows={dataDeals}
            columns={columns}
            totalCount={totalCount}
            page={dealsPage}
            rowHeight={45}
            pageSize={pageSize}
            sortModel={sortModel}
            onSortModelChange={handleSortModelChange}
            onPageChange={(_, value) => handlePageChange(value)}
            loading={isLoading}
        />
    );
};

export default BrokerDealsGrid;
